import { ymKey } from '../config/metric';
import { YandexMetrikaEvent } from '../types/metrica/YandexMetrikaEvent';
import { YandexMetrikaEventParams } from '../types/metrica/YandexMetrikaEventParams';

export const ymEvent = <T extends YandexMetrikaEvent>(
  event: T,
  params?: YandexMetrikaEventParams[T],
) => {
  const counterId = ymKey;
  if (typeof window === 'undefined' || !window.ym) return;
  window.ym(counterId, 'reachGoal', event, params);
};
